export default {
  PDFButtonFab: {
    baixar: 'Descargar',
    enviarEmail: 'Enviar por email',
    baixarPDF: 'Descargar PDF',
    baixarXLS: 'Descargar XLS',
    baixando: 'Descargando'
  }
};
